<template>
  <span>
    <scroll-observer
      @start="playAnimation"
      sentinalName="observer"
    ></scroll-observer>
    <!-- <span class="number">{{ theFormat(to) }}</span> -->
    <number
      ref="number"
      :from="from"
      :to="to"
      :format="theFormat"
      :duration="duration"
      :delay="delay"
      animationPaused
      easing="Power1.easeInOut"
    />
  </span>
</template>

<script>
import ScrollObserver from "./ScrollObserver.vue";
export default {
  components: { ScrollObserver },
  props: {
    from: {
      type: Number,
      default: 0,
    },
    to: {
      type: Number,
      default: 9,
    },
    duration: {
      type: Number,
      default: 2,
    },
    delay: {
      type: Number,
      default: 0,
    },
    isZero: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    theFormat(number) {
      if (number < 10 && this.isZero) return `0${parseInt(number)}`;
      else return parseInt(number);
    },
    completed() {
      console.log("Animation ends!");
    },
    playAnimation(value) {
      if (value) {
        this.$refs.number.restart();
      }
    },
  },
};
</script>

<style>
</style>